import { useCallback, useContext, useMemo } from 'react';
import { AnchoredSheet, AnchoredSheetTitleBar } from '@shared/components/AnchoredSheet';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { MBComboDatePicker } from '@shared/components/dateAndTime/comboDatePicker';
import { DatePickerValue } from '@shared/components/dateAndTime/comboDatePicker/props';
import { ColorThemeContext } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import { useAsISOString, useDefaultTime } from './hooks';
import { PickerProps } from './types';

export function MBCardInputBlockDatePicker({ block, anchorName, onClose, onChange }: PickerProps) {
  const colors = useContext(ColorThemeContext);
  const isDesktop = useIsDesktop();
  const defaultTime = useDefaultTime(block);
  const { values } = useCardFormContext();
  const value = useAsISOString(values[block.name]);

  const datePickerValue = useMemo<DatePickerValue>(() => ({ start: value }), [value]);

  const renderTitleBar = useCallback(() => {
    if (isDesktop) {
      return <AnchoredSheetTitleBar title={block.label} />;
    }

    return (
      <AnchoredSheetTitleBar
        title={block.label}
        rightIcon="exit"
        rightIconColor={colors.foregroundActive}
        onRightIconPress={onClose}
      />
    );
  }, [block, colors, onClose, isDesktop]);

  return (
    <AnchoredSheet
      initialSize="full"
      onClose={onClose}
      renderTitleBar={renderTitleBar}
      anchorName={anchorName}
    >
      <MBComboDatePicker
        autoFocus={block.autoFocus}
        label={block.label}
        mode={{
          date: 'single',
          time: block.fieldType === 'datetime' ? 'single' : undefined,
        }}
        defaultTime={defaultTime}
        onChange={onChange}
        value={datePickerValue}
      />
    </AnchoredSheet>
  );
}
